import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectProfileData } from '@pages/profile/store/selectors';
import { UseBankAccountFieldsProps } from '../types';
import { getAccountFieldTranslationKey, getAccountFieldType } from '../utils';

const useBankAccountFields = ({ currency }: UseBankAccountFieldsProps) => {
  const userProfile = useSelector(selectProfileData);
  const { isAwActive } = userProfile || {};

  const accountFieldType = useMemo(
    () => getAccountFieldType(currency),
    [currency]
  );

  const accountFieldKey = useMemo(
    () => getAccountFieldTranslationKey(accountFieldType, currency, isAwActive),
    [accountFieldType, currency, isAwActive]
  );

  return {
    accountFieldType,
    accountFieldKey,
    getAccountFieldType,
    getAccountFieldTranslationKey,
  };
};

export default useBankAccountFields;
